// API Configuration
export const apiBase = '';

// Helper function to construct API URLs
export function getApiUrl(path: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${apiBase}/${cleanPath}`;
} 

export const config = {
  env: window.location.hostname.includes('localhost') ? 'local' :
    window.location.hostname.includes('dev-explore.blockseer.com') ? 'dev' :
    'prod',
}